import { render, staticRenderFns } from "./dormBuild.vue?vue&type=template&id=5279edf2&"
import script from "./dormBuild.vue?vue&type=script&lang=js&"
export * from "./dormBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports